import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../api/apiCall";
import { User } from "../models/user";
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export function useCurrentUser() {
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthReady(true);
    });
    return () => unsubscribe();
  }, []);
  const { data: currentUser, isLoading } = useQuery<User>({
    queryKey: ["currentUser"],
    queryFn: () => apiCall<User>("/users/me", { method: "GET" }),
    enabled: isAuthReady,

    staleTime: 5 * 60 * 1000,
  });

  const role = currentUser?.role?.name ?? "";

  return {
    currentUser,
    isLoading,
    role,
    isSuperAdmin: role === "super_admin",
    isAdmin: role === "admin",
    isAccountant: role === "accountant",
    isClient: role === "client",
    canManage:
      role === "super_admin" || role === "admin" || role === "accountant",
  };
}
